<section id="group-img-edit" class="editCoverDiv">
    <div class="images-box">
        <div class="images-cover">
            <img class="images-cover-create c1" *ngIf="!coverShowImg" [src]="_imgCoverSuccess|getImgPath:'images'"
                 alt="">
            <img class="images-cover-create c2" *ngIf="coverShowImg" [src]="coverImgSrc" alt="">
            <input type="file" #coverChangeImg hidden (change)="createImage($event, 'square')">
            <button (click)="coverChangeImg.click()" class="position-btn">
                <mat-icon>
                    create
                </mat-icon>
            </button>
        </div>
        <div class="images-avatar">
            <!--            <img *ngIf="!coverShowImg" [src]="coverImg|getImgPath:'images'" alt="">-->
            <img *ngIf="!avatarShowImg" [src]="avatarImgSrc|getImgPath:'images'" alt="">
            <img *ngIf="avatarShowImg" [src]="avatarImgSrc" alt="">
            <!--            <mat-icon *ngIf="!avatarImgSrc">add_a_photo</mat-icon>-->
            <input type="file" #avatarChangeImg hidden (change)="createImage($event, 'circle')">
            <button (click)="avatarChangeImg.click()" class="position-btn">
                <mat-icon>
                    create
                </mat-icon>
            </button>
        </div>
    </div>
    <div class="images-save-btn-box" *ngIf="(avatarImgSrc && discardORSave) || (coverImgSrc && discardORSave)">
        <button class="save-btn mr-3" (click)="saveAvatarImage(avatarImgSrc,coverImgSrc)">Save</button>
        <button class="discard-btn ml-3" (click)="remuveAvatarImage('','')">DISCARD</button>
    </div>
</section>

<form [formGroup]="channelUpdateFormGroup">
    <div class="form-group w-80">
        <input type="text" formControlName="name" placeholder="Name">
    </div>


    <div class="submit-form">
        <button (click)="updateChannelInfo()">Save changes </button>
    </div>
</form>
